import {Routes, Route, BrowserRouter} from "react-router-dom"
import Login from './components/Login/Login';
import Home from './components/Home/Home'
import Previsualizar from './components/Crear/PrevisualizarGuiaProforma/Previsualizar';
import Imprimir from './components/Crear/ImprimirGuiaProforma/Imprimir';
import CrearResumenGuia from './components/Crear/CrearResumenGuia/CrearResumenGuia';
import ConsultaGuia from "./components/Consulta/ConsultaGuia/ConsultaGuia";
import ConsultaResumenGuias from './components/Consulta/ConsultaResumenGuia/ConsultaResumenGuia';
import DetallesGuia from './components/Consulta/ConsultaGuia/DetalleGuia/DetalleGuia';
import Indicadores from './components/Consulta/ConsultaIndicadores/Indicadores';
import Contactanos from './components/Contactanos/Contactanos';
import PerfilUsuario from './components/Usuario/PerfilUsuario';
import MisDestinarios from "./components/Consulta/ConsultaMisDestinatarios/MisDestinatarios"
import useAuth, { PERMISOS } from './components/useAuth/useAuth';
import AutenticacionRoute from './components/RutasProtegidas/AutenticadoRoute';
import NotFound from './components/helpers/NotFound/NotFound';
import { useSelector } from 'react-redux';
import { RootState } from './redux/store';
import RestablecerContrasenia from "./components/Login/RestablecerContrasenia/RestablcerContrasenia";
import RestablecerRoute from "./components/RutasProtegidas/Restablecer";
import ImprimirResumenGuia from "./components/Consulta/ConsultaResumenGuia/ImprimirResumenGuia/ImprimirResumenGuia";
import Guia from "./components/Crear/CrearGuia/Guia";
import "./bootstrap/css/bootstrap.min.css"
import "./assets/css/loader.css"
import "./assets/css/plugins.css"
import "./assets/css/dashboard/dash_1.css"
import "./assets/css/dashboard/dash_2.css"
import "./plugins/apex/apexcharts.css"
import Permisos from "./components/RutasProtegidas/Permisos";
import PageStructure from "./components/helpers/Structures/MainStructure";
import LiquidacionDeRutasContent from "./components/LiquidacionRutas/ConsultarLiquidacionRuta/LiquidacionRutaContent";
import LiquidacionRutaDetalle from "./components/LiquidacionRutas/DetallesLiquidacionRuta/LiquidacionRutaDetalle";
import VersionChecker from "./components/VersionChecker";

function App() {
  const { logout  } = useAuth();
  const usuarioVM = useSelector((state: RootState) => state.auth.usuarioActual);
  return (

    /*Produccion*/
    <BrowserRouter basename="App">
      <VersionChecker />
      <Routes>
        {/* Inicio de sesion */}
        <Route path="/" element={<Login authenticated={usuarioVM.autenticado} restablecer={usuarioVM.requiereCambiarContrasenia}/>} />

        <Route path="/" element={<RestablecerRoute restablecer={usuarioVM.requiereCambiarContrasenia}/>}> 
          <Route path="/restablecer" element={<RestablecerContrasenia restablecer={usuarioVM.requiereCambiarContrasenia} autenticado={usuarioVM.autenticado}/>} />
        </Route>

        {/*Rutas Públicas*/}
         <Route path='/home/consulta/guia' element= {<ConsultaGuia logout={logout}/>} />
         <Route path='/home/consulta/resumenGuias' element= {<ConsultaResumenGuias logout={logout} autenticado={usuarioVM.autenticado}/>} />
         <Route path='/home/consulta/detalles/:numeroGuia' element={<DetallesGuia logout={logout}/>}/>
          <Route path='/home/crear/imprimir/:numeroGuia' element = {<Imprimir logout={logout}/>}/> 
         <Route path='/home/consulta/resumenGuias/detalles/:idManifiesto' element= {<ImprimirResumenGuia logout={logout}/>} />
        {/* Contactanos */}
        <Route path='/home/contactanos' element= {<Contactanos logout={logout}/>} />

        <Route path="/" element={<AutenticacionRoute authenticated={usuarioVM.autenticado}/>}>
            {/* Contenido de la pagina */}
            <Route path="/home" element={<PageStructure Component={Home} logout={logout}/>} />

            {/* Vista Solo CONDUCTORES */}
            { <Route path="/" element={<Permisos rolUsuario={usuarioVM.rolUsuario} permisos={[PERMISOS.PUEDE_LIQUIDAR_RUTA]} />}>
                <Route path="/home/liquidarRuta" element= {<PageStructure Component={LiquidacionDeRutasContent} logout={logout}/>}/>
                <Route path="/home/liquidarRuta/:uuidManifiestoDetalle" element= {<PageStructure Component={LiquidacionRutaDetalle} logout={logout}/>}/>
            </Route> }
            {/* Fin vista Solo CONDUCTORES */}

            {/* Vista USUARIOS COMUNES */}
            <Route path="/" element={<Permisos permisos={[PERMISOS.GENERAL]} rolUsuario={usuarioVM.rolUsuario} />}>
                <Route path='/home/crear/guia' element ={<Guia logout={logout}/>}/>
                <Route path='/home/previsualizar' element= {<Previsualizar logout={logout}/>} />
                <Route path='/home/crear/resumenGuia' element={<CrearResumenGuia logout={logout}/>}/>  
                
                <Route path='/home/consulta/Destinatarios' element= {<MisDestinarios logout={logout}/>} /> 
                <Route path='/home/consulta/indicadores' element={<Indicadores logout={logout}/>}/>
            </Route>    
            {/* Fin vista USUARIOS COMUNES */}
      
       
            {/* Usuario */}
            <Route path='/home/usuario' element= {<PerfilUsuario logout={logout}/>} />

        </Route>
           

        {/* 404 - Not Found */}
        <Route path='*' element= {<NotFound/>} />
        
      </Routes>
    </BrowserRouter>
  );
}

export default App;
